import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListProjectResale from "../Project Resale/listResaleProject";
import ListInterestedProjectResale from "../Project Resale/listInterestedProjectResale";
import UserProjectViewList from "../Project Resale/userProjectView";
import "./headerResaleProject.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "agent_header_tab";

const HeaderResaleProject = () => {
  const [selectedTable, setSelectedTable] = useState("resale_project_list");
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    // localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "resale_project_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("resale_project_list")}
            >
              Project Resale
            </h4>

            <h4
              className={selectedTable === "interested_resale_project" ? "clicked" : ""}
              onClick={() => handleTableSelection("interested_resale_project")}
            >
              Interested Resale Project
            </h4>

            <h4
              className={selectedTable === "user_view_resale_project" ? "clicked" : ""}
              onClick={() => handleTableSelection("user_view_resale_project")}
            >
              User View Project Resale
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "resale_project_list" ? "block" : "none" }}>
            <ListProjectResale />
          </div>

          <div style={{ display: selectedTable === "interested_resale_project" ? "block" : "none" }}>
            <ListInterestedProjectResale />
          </div>

          <div style={{ display: selectedTable === "user_view_resale_project" ? "block" : "none" }}>
            <UserProjectViewList />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderResaleProject;
